export const MAX_FILES     = 5;
export const MAX_FILE_SIZE = 2 * 1024 * 1024;
